import { render, staticRenderFns } from "./PayAll.vue?vue&type=template&id=ed87d4c0&"
import script from "./PayAll.vue?vue&type=script&lang=ts&"
export * from "./PayAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports